import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBContainer,
} from "mdb-react-ui-kit";

//primereact
import { Steps } from "primereact/steps";
import { useState, useRef, useEffect } from "react";
import EditModalBoxStep1 from "./edit.modalbox.step1";
import EditModalBoxStep2 from "./edit.modalbox.step2";

export default function EditModalBox({
  title,
  show,
  close,
  getListing,
  selectedId,
  selectedData,
}) {
  const [roomId, setRoomId] = useState("");
  const [step, setStep] = useState(0);
  const items = [
    {
      label: "Room Display Details",
      command: (event) => {
        setStep(0);
      },
    },
    {
      label: "Room Pricing Details",
      command: (event) => {
        setStep(1);
      },
    },
  ];

  const handleNextStep = () => {
    setStep(step + 1);
  };

  const handlePrevStep = () => {
    setStep(step - 1);
  };
  const modalTopRef = useRef();
  const scrollToTop = () => {
    modalTopRef.current?.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
    });
  };
  useEffect(() => {
    setTimeout(() => {
      scrollToTop();
    }, 500);
  }, []);
  return (
    <MDBModal staticBackdrop tabIndex="-1" show={show}>
      <MDBModalDialog scrollable className="create-modalbox" size="lg">
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>{title}</MDBModalTitle>
            <MDBBtn
              className="btn-close"
              color="none"
              onClick={() => close()}
            ></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
            <div ref={modalTopRef}></div>
            <MDBContainer breakpoint="none" className="">
              <Steps model={items} activeIndex={step} readOnly={false} />
            </MDBContainer>
            <MDBContainer>
              {step == 0 ? (
                <EditModalBoxStep1
                  selectedData={selectedData}
                  handleNextStep={handleNextStep}
                  getListing={getListing}
                  setRoomId={setRoomId}
                />
              ) : step == 1 ? (
                <EditModalBoxStep2
                  selectedData={selectedData}
                  getListing={getListing}
                  selectedId={selectedId}
                  roomId={roomId}
                  close={close}
                />
              ) : (
                <EditModalBoxStep2
                  selectedData={selectedData}
                  getListing={getListing}
                  selectedId={selectedId}
                  roomId={roomId}
                  close={close}
                />
              )}
            </MDBContainer>
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}
